export const environment = {
    production: true,
    apiEndpoint: 'https://api-pb.qivos.net/sso/v1'
  };
  
  